export default {
  data() {
    return {
      otaMessageTypeConst: [
        {label: this.$t('ota_message.type.after_create'), value: 'AFTER_CREATE'},
        {label: this.$t('ota_message.type.before_arrival'), value: 'BEFORE_ARRIVAL'},
        {label: this.$t('ota_message.type.before_departure'), value: 'BEFORE_DEPARTURE'},
        {label: this.$t('ota_message.type.after_departure'), value: 'AFTER_DEPARTURE'},
      ],
    };
  },
  methods: {
    displayForOtaMessageTypeConst(value) {
      const result = this.otaMessageTypeConst.find((el) => el.value === value);
      return result ? result.label : value;
    },
  },
};
